




















































































import { Component, Vue, Watch, Prop, Mixins } from 'vue-property-decorator';
import { ContactV2 } from '@/models/Contact';
import SingleSelect from '@/components/SingleSelect.vue';
import http from '@/services/Http';
import { TextValuePair } from '@/models/TextValuePair';
import { websiteText } from '@/mixins/websiteTexts';

declare var grecaptcha: any;

@Component({
    components: {
        SingleSelect
    }
})
export default class ContactFormV2 extends Vue {
    protected form: ContactV2;
    private showForm: boolean = true;
    private errors: { [key: string]: boolean } = {
        name: false,
        email: false,
        phone: false,
        orderNumber: false,
        case: false,
        message: false
    };
    private emailError: boolean = false;
    private ordernumberError: boolean = false;
    private errorMsgs: string[] = [];
    private title: string;
    private caseTypes: Array<TextValuePair>;
    private text: '';
    private placeholderDescription: string = '';
    private showOrderNumberField: boolean = false;
    private dataLayer = (window as any).dataLayer || [];
    private selectedOrgName = '';
    private translations: any = window.__litium.translation;
    private _websiteText(text: string, extraValues?: string[]) {
        return websiteText(text, extraValues);
    }

    private selectedProducts: string[] = [];
    constructor() {
        super();
        this.form = {
            name: '',
            email: '',
            phone: '',
            orderNumber: '',
            case: '',
            message: '',
            token: ''
        };
        this.selectedOrgName = this.$attrs['data-retailer-name'];
        this.title = this.$attrs['data-title'];
        this.text = JSON.parse(this.$attrs['data-text']);
        this.placeholderDescription = this.$attrs['data-placeholder-description'];
        this.showOrderNumberField = this.$attrs['data-show-ordernumber-field'].toLowerCase() == 'true' ? true : false;

        this.caseTypes = JSON.parse(this.$attrs['data-casetypes']).map(
            (val: string) =>
                ({
                    text: val,
                    value: val
                } as TextValuePair)
        );
    }

    private clearError(fieldName: string) {
        this.errors[fieldName] = false;
    }

    private updateProducts(selProds: string[]) {
        this.form.case = selProds[0];
    }

    private submitForm() {
        this.errorMsgs = [];
        this.emailError = false;
        const recaptchaSiteKey = (window as any).__litium.recaptchaSiteKey as string;

        if (!this.validateForm()) {
            return;
        } else {
            const submit = this.submit;
            grecaptcha.ready(function() {
                grecaptcha
                    .execute(recaptchaSiteKey, {
                        action: 'submit'
                    })
                    .then(function(token: string) {
                        submit(token);
                    });
            });
        }
    }

    private submit(token: string) {
        this.form.token = token;

        const contactForm = http.post(`/api/contactform/v2`, this.form);
        contactForm.then((response: any) => {
            this.showForm = false;
            this.dataLayer.push({
                event: 'reseller-form',
                'reseller-formtype': 'contact',
                email: this.form.email,
                store: this.selectedOrgName,
                name: this.form.name,
                phoneNumber: this.form.phone,
                case: this.form.case,
                message: this.form.message,
                orderNumber: this.form.message
            });
        });
    }
    private validateForm(): boolean {
        const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

        var returnValue = true;

        // var test = Mixins.name['websiteText'];
        // console.log(Mixins);

       // console.log(this._websiteText('site.contactform.missingname'));

        if (this.form.name == '') {
            this.errorMsgs.push(this._websiteText('site.contactform.missingname'));
            this.errors['name'] = true;
            returnValue = false;
        }
        if (this.form.email == '') {
            this.errorMsgs.push(this._websiteText('site.contactform.missingemail'));
            this.errors['email'] = true;
            returnValue = false;
        } 
        else if (!reg.test(this.form.email)) {
            this.errorMsgs.push(this._websiteText('site.contactform.emailincorrect'));
            this.errors['email'] = true;
            returnValue = false;
        }
        if (this.form.phone == '') {
            this.errorMsgs.push(this._websiteText('site.contactform.missingphone'));
            this.errors['phone'] = true;
            returnValue = false;
        }
        if (this.caseTypes != null && this.caseTypes.length > 0 && this.form.case == '') {
            this.errorMsgs.push(this._websiteText('site.contactform.missingcase'));
            this.errors['case'] = true;
            returnValue = false;
        }
        if (this.form.message == '') {
            this.errorMsgs.push(this._websiteText('site.contactform.missingmessage', [this.placeholderDescription]));
            this.errors['message'] = true;
            returnValue = false;
        }

        return returnValue;
    }
}
